/**
 * Dispatched on `window` by our `OptanonWrapper`, which OneTrust calls once it
 * loads and again whenever the visitor changes their consent.
 */
export const ONE_TRUST_CONSENT_CHANGED_EVENT = 'order:onetrust-consent-changed';
